var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetain2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 553.908,
    height: 299.121,
    viewBox: "0 0 553.908 299.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824",
    transform: "translate(0 -44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449",
    transform: "translate(252.175 196.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(2.62 68.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M289.25,359.949c1.5.63,3.355-.31,4.208-2.137l28.251-60.476-9.873-4.144L287.845,355.4C287.112,357.3,287.733,359.312,289.25,359.949Z",
    transform: "translate(-287.537 -293.192)",
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(28.686 67.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M349.242,359.8c1.5-.642,2.11-2.626,1.389-4.511L326.794,292.94l-9.841,4.217L345,357.648C345.854,359.5,347.73,360.446,349.242,359.8Z",
    transform: "translate(-316.953 -292.94)",
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M331.518,216.242s30.092,7.63,26,43.408c-3.759,32.863-34.05,43.725-56.607,35.992s-15.172-30.416-15.172-30.416Z",
    transform: "translate(-284.581 -216.242)",
    fill: "#e2dfe5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(0 44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    d: "M0,0H190.274a4.169,4.169,0,0,1,4.169,4.169V190.457a4.169,4.169,0,0,1-4.169,4.169H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(0.315 7.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M186.865,56.04V230.354a3.5,3.5,0,0,1-3.5,3.5H.355V52.543H183.368A3.5,3.5,0,0,1,186.865,56.04Z",
    transform: "translate(-0.355 -52.543)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458",
    transform: "translate(0.003 7.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M166.887,52.543.315,221.713l-.05.051L0,200.6l.311-.311,147.5-147.744Z",
    transform: "translate(-0.004 -52.543)",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459",
    transform: "translate(0.314 7.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M116.048,52.543.355,170.044V149.123l96.42-96.579Z",
    transform: "translate(-0.355 -52.543)",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465",
    transform: "translate(4.806 5.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 3.642,
    height: 186.046,
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461",
    transform: "translate(36.054)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    width: 3.642,
    height: 186.046,
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462",
    transform: "translate(72.107)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 3.642,
    height: 186.046,
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    transform: "translate(108.161)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 3.642,
    height: 186.046,
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(144.215)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 3.642,
    height: 186.046,
    fill: "#eeecf1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(0 49.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    transform: "translate(0 92.28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 3.642,
    height: 188.568,
    transform: "translate(0 3.642) rotate(-90)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    transform: "translate(0 46.981)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 3.642,
    height: 188.568,
    transform: "translate(0 3.642) rotate(-90)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 3.642,
    height: 188.568,
    transform: "translate(0 3.642) rotate(-90)",
    fill: "#eeecf1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(183.096 186.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M228.126,233.069s7.638-11.9,7.2-13.608c-.283-1.092-3.439,3.041-3.439,3.041s3.128-8.912,2-9.423-6.569,15.8-6.569,15.8,3.679-23.112,2.339-23.514-5.438,23.037-5.438,23.037-3.154-18.824-4.677-17.843,1.474,17.431,1.474,17.431-5.7-13.623-6.46-11.446c-.676,1.943,2.841,11.942,2.841,11.942s-11.069-17.183-10.764-14.39,10.05,19.457,10.05,19.457Z",
    transform: "translate(-206.625 -205.364)",
    fill: "#90a38d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(8.983 26.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M229.6,252.165H219.4a1.052,1.052,0,0,1-1.07-.911l-1.56-14.861a1.036,1.036,0,0,1,1.07-1.109H231.16a1.036,1.036,0,0,1,1.07,1.109l-1.56,14.861A1.052,1.052,0,0,1,229.6,252.165Z",
    transform: "translate(-216.762 -235.284)",
    fill: "#bbafc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(6.725 26.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M227.051,252.165h-10.2a1.052,1.052,0,0,1-1.07-.911l-1.56-14.861a1.036,1.036,0,0,1,1.07-1.109h13.322a1.036,1.036,0,0,1,1.07,1.109l-1.56,14.861A1.052,1.052,0,0,1,227.051,252.165Z",
    transform: "translate(-214.214 -235.284)",
    fill: "#ddd7e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    transform: "translate(68.758 164.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554",
    transform: "translate(10.485 99.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M91.088,358.021c-1.472-.631-2.073-2.581-1.365-4.433L113.152,292.3l9.674,4.145L95.26,355.908C94.418,357.724,92.574,358.658,91.088,358.021Z",
    transform: "translate(-89.426 -292.304)",
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555",
    transform: "translate(35.917 99.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M150.032,358.17c-1.478.619-3.3-.3-4.136-2.1l-27.769-59.443,9.7-4.074L151.413,353.7C152.133,355.569,151.522,357.543,150.032,358.17Z",
    transform: "translate(-118.127 -292.552)",
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556",
    transform: "translate(0 30.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M102.459,214.485s-28.5,9.653-24.476,44.82c3.7,32.3,33.47,42.979,55.642,35.378s14.913-29.9,14.913-29.9Z",
    transform: "translate(-77.594 -214.485)",
    fill: "#e2dfe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    transform: "translate(23.347 87.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M138.8,283.015c0,2.167-7.8,3.923-17.427,3.923s-17.427-1.756-17.427-3.923,7.8-3.923,17.427-3.923S138.8,280.848,138.8,283.015Z",
    transform: "translate(-103.941 -279.092)",
    fill: "#bbafc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "translate(28.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M124.515,181.525s-7.995-4.633-12.075,3.088-2.07,30.146-2.07,30.146H123.34l1.174-33.234Z",
    transform: "translate(-109.874 -180.147)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    transform: "translate(76.345 22.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M169.952,205.023l1.153,5.569-7.354-.544v-2.761Z",
    transform: "translate(-163.75 -205.023)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    transform: "translate(61.603 25.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M154.614,221.929l2.967-12.6,11.45.962s7.021,29.142-3.819,34.135c-10.013,4.612-18.1-4.818-18.1-4.818Z",
    transform: "translate(-147.113 -209.327)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561",
    transform: "translate(62.885 138.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M164.495,336.272l.889,13.284H148.56V336.272Z",
    transform: "translate(-148.56 -336.272)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    transform: "translate(99.684 103.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M202.528,296.952l9.1,9.719L198.494,317.4l-8.406-10.286Z",
    transform: "translate(-190.088 -296.952)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563",
    transform: "translate(50.947 90.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M169.191,298.113v35.564H140.447L135.088,284.6l22.9-2.562Z",
    transform: "translate(-135.088 -282.036)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564",
    transform: "translate(24.865 63.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M200.429,287.829s-23.385-27.769-37.513-32.154-54.942-4.047-54.942-4.047-7.417,21.585,4.275,26.944,34.26,4.385,38.079,6.333,27.2,24.846,27.2,24.846Z",
    transform: "translate(-105.654 -251.622)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    transform: "translate(17.386 23.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M97.214,232.082s2.184-21.967,13.082-24.66,18.463-.421,24.563,2.18c5.9,2.513,14.073,11.972,14.073,11.972l-4.7,20.909-6.053-1.137.1,7.989-32.1.855-4.074-16.743Z",
    transform: "translate(-97.214 -206.21)",
    fill: "red"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(39.257 17.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M122.846,199.824l-.95,6.9s.971,2.154,4.961,3.038c2.973.658,4.122.124,4.122.124l.062-3.552.056-3.464-7.066-2.606Z",
    transform: "translate(-121.896 -199.824)",
    fill: "#f78f77"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(41.392 17.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M124.306,200.319a2.278,2.278,0,0,0,.108.694c1.07,3.658,5.187,4.982,6.9,5.376l.056-3.464Z",
    transform: "translate(-124.305 -200.319)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    transform: "translate(35.83 1.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M134.359,185.351s2.43,9.147.341,13.756-6.36,3.178-8.843,1.843a8.787,8.787,0,0,1-3.453-3.131,3.744,3.744,0,0,1-3.871-2.077c-1.29-2.533.121-5,1.614-5.381a3.9,3.9,0,0,1,3,.882l-.922-2.691S129.661,176.733,134.359,185.351Z",
    transform: "translate(-118.028 -182.205)",
    fill: "#f78f77"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(49.688 11.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M134.117,197.44a.287.287,0,0,1-.122-.028.276.276,0,0,1-.124-.368,4.425,4.425,0,0,0-.175-3.411.274.274,0,0,1,.493-.241,4.919,4.919,0,0,1,.175,3.9A.274.274,0,0,1,134.117,197.44Z",
    transform: "translate(-133.668 -193.239)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(37.783 11.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M122.438,196.437a.275.275,0,0,1-.228-.121l-1.93-2.837a.274.274,0,1,1,.453-.308l1.931,2.838a.274.274,0,0,1-.073.38A.268.268,0,0,1,122.438,196.437Z",
    transform: "translate(-120.232 -193.051)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(37.357 13.218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M121.674,195.625l-1.651-.014a.274.274,0,0,1,0-.548l1.65.014a.274.274,0,0,1,0,.548Z",
    transform: "translate(-119.752 -195.063)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    transform: "translate(45.095 15.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M130.627,200.141a1.6,1.6,0,0,1-.953-.3,3.216,3.216,0,0,1-1.187-2.042.274.274,0,0,1,.4-.277l3.17,1.65a.274.274,0,0,1,.037.463A2.759,2.759,0,0,1,130.627,200.141Zm-1.44-1.847a2.4,2.4,0,0,0,.806,1.1,1.362,1.362,0,0,0,1.358.028Z",
    transform: "translate(-128.484 -197.489)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    transform: "translate(45.499 7.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M129.214,189.808a.269.269,0,0,1-.162-.053.274.274,0,0,1-.058-.383c.742-1.01,2.536-.611,2.612-.594a.274.274,0,0,1-.122.534c-.422-.1-1.609-.214-2.049.384A.271.271,0,0,1,129.214,189.808Z",
    transform: "translate(-128.94 -188.686)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(50.668 7.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M136.633,189.895a.273.273,0,0,1-.233-.129.95.95,0,0,0-1.246-.287.274.274,0,0,1-.214-.5,1.5,1.5,0,0,1,1.926.505.274.274,0,0,1-.092.376A.267.267,0,0,1,136.633,189.895Z",
    transform: "translate(-134.773 -188.821)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(50.855 94.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M168.316,301.941a.274.274,0,0,1-.2-.089c-.11-.12-11.035-11.931-14.506-12.709-3.537-.791-18.226-2.088-18.374-2.1a.274.274,0,1,1,.048-.545c.605.053,14.874,1.311,18.446,2.112,3.638.815,14.336,12.38,14.789,12.871a.275.275,0,0,1-.2.461Z",
    transform: "translate(-134.984 -286.496)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    transform: "translate(69.265 89.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M156.034,288.544a.3.3,0,0,1-.083-.012.276.276,0,0,1-.191-.27c.034-1.052.268-6.331,1.57-7.006a.758.758,0,0,1,.808.07c1.876,1.235-1.486,6.5-1.875,7.094A.278.278,0,0,1,156.034,288.544Zm1.631-6.825a.175.175,0,0,0-.082.022c-.646.335-1.069,3.127-1.223,5.481,1.217-2.074,2.408-4.826,1.477-5.439A.326.326,0,0,0,157.665,281.72Z",
    transform: "translate(-155.76 -281.171)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    transform: "translate(89.719 97.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M179.117,307.914a.275.275,0,0,1-.195-.468L195.807,290.5a.274.274,0,0,1,.388.387l-16.884,16.941A.273.273,0,0,1,179.117,307.914Z",
    transform: "translate(-178.842 -290.424)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    transform: "translate(56.023 134.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M161.474,332.648H141.09a.274.274,0,0,1,0-.548h20.384a.274.274,0,0,1,0,.548Z",
    transform: "translate(-140.816 -332.1)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(76.346 9.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M169.952,206.913a6.2,6.2,0,0,0,6.2-6.2V190.7h-12.4v10.015A6.2,6.2,0,0,0,169.952,206.913Z",
    transform: "translate(-163.751 -190.697)",
    fill: "#f2513b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    transform: "translate(76.346 8.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M163.751,190.605c0,.393,2.776.712,6.2.712s6.2-.319,6.2-.712-2.776-.713-6.2-.713S163.751,190.211,163.751,190.605Z",
    transform: "translate(-163.751 -189.892)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591",
    transform: "translate(71.71 12.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M158.519,200.049c0-3.3,2.079-5.988,4.635-5.988s4.636,2.687,4.636,5.988-2.08,5.989-4.636,5.989S158.519,203.352,158.519,200.049Zm1.1,0c0,2.7,1.588,4.893,3.539,4.893s3.54-2.195,3.54-4.893-1.589-4.892-3.54-4.892S159.615,197.352,159.615,200.049Z",
    transform: "translate(-158.519 -194.061)",
    fill: "#f2513b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(71.348 15.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M158.833,208.011s-1.109-7.043-.578-8.4c.721-1.84,4.853-1.84,4.853-1.84v4.723a8.881,8.881,0,0,1,1.225,7.244C163.328,214.213,158.833,208.011,158.833,208.011Z",
    transform: "translate(-158.111 -197.77)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593",
    transform: "translate(79.19 13.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M168.542,197.849a4.1,4.1,0,0,1,1.521-1.213c2-.977,8.082-2.722,9.525-.864,1.382,1.78-1.966,2.854-1.966,2.854s2.872-.326,2.424,1.708a2.8,2.8,0,0,1-2.217,2s3.019-.053,1.576,2.24-7.864,3.551-10.094,3.14-.195-3.106-.195-3.106-2.346-.759-2.142-2.092c.215-1.412,2.189-1.659,2.189-1.659A1.938,1.938,0,0,1,168.542,197.849Z",
    transform: "translate(-166.961 -194.952)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    transform: "translate(81.849 16.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M170.235,201.5a.275.275,0,0,1-.074-.539l7.727-2.162a.274.274,0,0,1,.148.528l-7.727,2.162A.269.269,0,0,1,170.235,201.5Z",
    transform: "translate(-169.961 -198.788)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(82.004 20.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M170.41,205.591a.274.274,0,0,1-.07-.54l7.779-2.074a.274.274,0,1,1,.141.529l-7.779,2.075A.279.279,0,0,1,170.41,205.591Z",
    transform: "translate(-170.136 -202.968)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    transform: "translate(76.072 20.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M164.939,210.583a.27.27,0,0,1-.094-.017.274.274,0,0,1-.164-.351c1.215-3.356-1.17-6.96-1.194-7a.274.274,0,0,1,.455-.306c.105.156,2.565,3.869,1.254,7.49A.273.273,0,0,1,164.939,210.583Z",
    transform: "translate(-163.441 -202.792)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(38.256 23.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M130.205,211.16a20.221,20.221,0,0,1-4.24-.526c-4.074-.884-5.136-3.439-5.179-3.547a.274.274,0,0,1,.51-.2c.009.024,1.014,2.4,4.786,3.216,3.84.834,5.5.4,5.519.393a.274.274,0,0,1,.149.527A6.2,6.2,0,0,1,130.205,211.16Z",
    transform: "translate(-120.766 -206.711)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    transform: "translate(46.496 9.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M130.339,193.291a.276.276,0,0,1-.274-.283l.052-1.628a.275.275,0,0,1,.079-.184l.79-.8a.274.274,0,1,1,.389.386l-.714.72-.049,1.52A.274.274,0,0,1,130.339,193.291Z",
    transform: "translate(-130.065 -190.319)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599",
    transform: "translate(51.293 9.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M135.753,193.718a.274.274,0,0,1-.274-.277l.02-1.63a.276.276,0,0,1,.066-.175l.694-.807a.274.274,0,0,1,.415.358l-.628.73-.02,1.529A.274.274,0,0,1,135.753,193.718Z",
    transform: "translate(-135.479 -190.734)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    transform: "translate(56.423 33.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M143.046,243.985a.274.274,0,0,1-.274-.275v-7.384a.288.288,0,0,1,.014-.087,36.822,36.822,0,0,0,1.459-7.738c.389-4.487-2.9-9.8-2.936-9.852a.274.274,0,0,1,.465-.291c.139.223,3.421,5.518,3.016,10.19a37.778,37.778,0,0,1-1.471,7.822v7.34A.274.274,0,0,1,143.046,243.985Z",
    transform: "translate(-141.268 -218.23)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601",
    transform: "translate(38.201 47.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M121.109,240.2a.285.285,0,0,1-.274-.254c-.167-2.33-.32-6.3.519-6.706a.527.527,0,0,1,.612.136c1.3,1.192-.4,6.089-.6,6.643A.276.276,0,0,1,121.109,240.2Zm.432-6.461c-.268.241-.335,2.4-.241,4.688.532-1.873.912-4.086.3-4.647A.184.184,0,0,0,121.541,233.74Z",
    transform: "translate(-120.704 -233.193)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602",
    transform: "translate(37.853 0.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M123.554,192.134s3.019-3,5.674-3.917c1.768-.609,2.852-.985,2.852-.985l-.458-3.266L133.4,187.1l1.585-.274s.149-5.873-5.337-5.691-7.633,1.827-8.66,3.837-.581,5.268-.581,5.268A3.114,3.114,0,0,1,123.554,192.134Z",
    transform: "translate(-120.311 -181.129)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603",
    transform: "translate(37.774 1.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M120.5,188.158a.273.273,0,0,1-.272-.244c-.005-.05-.477-4.992,5.391-6.512a.272.272,0,0,1,.334.2.275.275,0,0,1-.2.335c-5.4,1.4-5,5.738-4.984,5.922a.274.274,0,0,1-.243.3Z",
    transform: "translate(-120.222 -181.392)",
    fill: "#ffb255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(104.467 101.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M229.97,294.451c-4.615.378-11.162,4.692-14.5,5.178s-8.669-.767-9.368.983-.5,6.766-4.3,9.392-6.122,3.2-6.31,4.848c-.131,1.152,4.1,7.232,7.017,10.916l-1.074,1.376,3.093,3.493,7.37-6.524c.521-.261-.746-4.086.415-4.372s4.493-1.04,6.19-1.477c0,0,18.189-15.141,21.24-18.672a.706.706,0,0,0-.121-1.008C238.113,297.372,233.725,294.145,229.97,294.451Z",
    transform: "translate(-195.486 -294.431)",
    fill: "#bc574a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605",
    transform: "translate(56.678 144.983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M185.037,356.108c-3.566-2.953-11.265-4.438-13.995-6.423s-5.669-6.6-7.392-5.84-5.083,4.5-9.637,3.719-6.615-1.988-7.9-.938c-.9.734-2.113,8.042-2.6,12.714l-1.73.235-.225,4.66,9.831.479c.555.177,2.319-3.445,3.35-2.839s3.942,2.393,5.462,3.265c0,0,23.592,1.867,28.241,1.471a.706.706,0,0,0,.618-.805C188.826,363.886,187.939,358.511,185.037,356.108Z",
    transform: "translate(-141.555 -343.761)",
    fill: "#bc574a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(96.401 237.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M109.979,355.794a1.19,1.19,0,0,1-.97-1.878l64.117-90.5a1.19,1.19,0,0,1,1.942,1.376l-64.117,90.5A1.188,1.188,0,0,1,109.979,355.794Z",
    transform: "translate(-108.79 -262.913)",
    fill: "#e0dfe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    transform: "translate(224.648 237.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M318.826,355.794a1.19,1.19,0,0,1-.972-.5l-64.117-90.5a1.19,1.19,0,0,1,1.941-1.376l64.118,90.5a1.19,1.19,0,0,1-.97,1.878Z",
    transform: "translate(-253.518 -262.913)",
    fill: "#e0dfe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(104.299 230.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M295.333,264.223H122.751a5.049,5.049,0,1,1,0-10.1H295.333a5.049,5.049,0,1,1,0,10.1Z",
    transform: "translate(-117.702 -254.125)",
    fill: "#bdb3c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670",
    transform: "translate(87.691 214.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    transform: "translate(32.97 9.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M139.464,246.986a76.275,76.275,0,0,1,7.688,1.613c2.895.86,7.388,1.855,9.285,1.357s2.1.3,1.6,1.406-2.7,1.7-2.7,1.7,2.3,9.194,1.4,9.947-3.495-2.15-3.495-2.15a2.159,2.159,0,0,1-1.2.752,3.918,3.918,0,0,1-1.7-.323,1.789,1.789,0,0,1-1.481,1.075,2.64,2.64,0,0,1-2.014-.43s-.7,1.539-1.5,1.2-4.393-1.415-4.193-2.49,3.2-.86,3.2-.86l.4-1.827s-3.094,2.365-5.99.752-2.588-5.646-2.588-5.646Z",
    transform: "translate(-136.167 -246.986)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(49.152 15.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M155.321,261.864a.267.267,0,0,1-.175-.064.272.272,0,0,1-.035-.385c2.121-2.549-.62-7.511-.648-7.561a.274.274,0,1,1,.478-.268c.122.217,2.954,5.342.591,8.181A.274.274,0,0,1,155.321,261.864Z",
    transform: "translate(-154.429 -253.445)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M99.863,236.177s-2.2,9.578.273,14.582c3.531,7.135,33.091,3.339,33.091,3.339l2-8.343-16.65-5.155.055-.334S112.071,238.538,99.863,236.177Z",
    transform: "translate(-98.96 -236.177)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668",
    transform: "translate(46.876 19.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M152.134,262.8a.274.274,0,0,1-.214-.445c1.278-1.6.32-4.07.31-4.094a.274.274,0,0,1,.51-.2c.045.113,1.082,2.789-.391,4.638A.274.274,0,0,1,152.134,262.8Z",
    transform: "translate(-151.86 -257.885)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(43.381 20.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M148.19,263.606a.274.274,0,0,1-.171-.488c1.364-1.092,1.179-3.5,1.177-3.521a.274.274,0,0,1,.249-.3.269.269,0,0,1,.3.249c.01.111.214,2.719-1.38,4A.273.273,0,0,1,148.19,263.606Z",
    transform: "translate(-147.916 -259.299)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_819",
    "data-name": "Group 819",
    transform: "translate(340.832 78.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(72.049 90.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(5.947 2.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M813.848,188.876H807.9v-11.47a2.974,2.974,0,0,1,5.948,0Z",
    transform: "translate(-807.9 -174.432)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(0 2.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M807.136,188.876h-5.947v-11.47a2.973,2.973,0,1,1,5.947,0Z",
    transform: "translate(-801.189 -174.432)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(17.855 2.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M827.287,188.876h-5.948v-11.47a2.974,2.974,0,0,1,5.948,0Z",
    transform: "translate(-821.339 -174.432)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(1.422 0.635)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 2.713,
    height: 2.713,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(7.564 0.635)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 2.713,
    height: 2.713,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(19.472 0.892)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 2.713,
    height: 2.713,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(0.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M805.443,173.165h-2.755a.635.635,0,1,1,0-1.271h2.755a.635.635,0,1,1,0,1.271Z",
    transform: "translate(-802.053 -171.894)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(6.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M812.283,173.165h-2.755a.635.635,0,0,1,0-1.271h2.755a.635.635,0,0,1,0,1.271Z",
    transform: "translate(-808.893 -171.894)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(18.816 0.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M825.813,173.455h-2.755a.635.635,0,1,1,0-1.271h2.755a.635.635,0,0,1,0,1.271Z",
    transform: "translate(-822.423 -172.184)",
    fill: "#ddd7e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(0 49.376)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 37.072,
    height: 53.906,
    rx: 5.895,
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(148.506 43.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    d: "M4.535,0H27.879a4.535,4.535,0,0,1,4.535,4.535v8.519a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4.535A4.535,4.535,0,0,1,4.535,0Z",
    fill: "#c7bfce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(120.81 43.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    d: "M3.761,0H18.539A3.761,3.761,0,0,1,22.3,3.761v9.292a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.761A3.761,3.761,0,0,1,3.761,0Z",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(62.212 56.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M920.053,138.538H792.57a2.482,2.482,0,0,1,0-4.965H920.053Z",
    transform: "translate(-790.088 -133.573)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(51.174 81.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M920.115,167.118h-140a2.482,2.482,0,1,1,0-4.965h140Z",
    transform: "translate(-777.632 -162.153)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(40.419 106.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M919.613,195.7H767.978a2.482,2.482,0,1,1,0-4.965H919.613Z",
    transform: "translate(-765.495 -190.732)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(15.41 29.44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 7.667,
    height: 130.931,
    fill: "#d3ccd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(190.049 29.44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 7.667,
    height: 130.931,
    fill: "#d3ccd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(9.544 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 194.087,
    height: 35.619,
    rx: 8.116,
    fill: "#c7bfce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(68.21 59.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(1.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M810.158,143.541a5.886,5.886,0,1,1-5.978-5.793A5.885,5.885,0,0,1,810.158,143.541Z",
    transform: "translate(-798.387 -137.747)",
    fill: "#90a38d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(1.871 7.557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M809.647,160.265l-8.452.027a.874.874,0,0,1-.89-.752l-1.333-12.308a.859.859,0,0,1,.884-.922l11.038-.035a.859.859,0,0,1,.89.915l-1.253,12.317A.873.873,0,0,1,809.647,160.265Z",
    transform: "translate(-798.968 -146.275)",
    fill: "#ddd7e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(0 7.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M807.536,160.271l-8.452.028a.874.874,0,0,1-.89-.752l-1.333-12.308a.859.859,0,0,1,.883-.922l11.038-.035a.859.859,0,0,1,.89.915l-1.253,12.317A.871.871,0,0,1,807.536,160.271Z",
    transform: "translate(-796.857 -146.282)",
    fill: "#eeecf1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(160.92 64.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(5.948 2.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M914.141,160.154h-5.948v-11.47a2.974,2.974,0,0,1,5.948,0Z",
    transform: "translate(-908.193 -145.71)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(0 2.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M907.429,160.154h-5.948v-11.47a2.974,2.974,0,1,1,5.948,0Z",
    transform: "translate(-901.481 -145.71)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(17.855 2.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M927.579,160.154h-5.948v-11.47a2.974,2.974,0,1,1,5.948,0Z",
    transform: "translate(-921.631 -145.71)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(1.422 0.635)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 2.713,
    height: 2.713,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(7.565 0.635)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 2.713,
    height: 2.713,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(19.473 0.892)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 2.713,
    height: 2.713,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(0.766 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M905.735,144.443H902.98a.635.635,0,1,1,0-1.27h2.755a.635.635,0,1,1,0,1.27Z",
    transform: "translate(-902.345 -143.173)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(6.827 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M912.575,144.443H909.82a.635.635,0,1,1,0-1.27h2.755a.635.635,0,1,1,0,1.27Z",
    transform: "translate(-909.185 -143.173)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(18.817 0.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M926.106,144.733h-2.755a.635.635,0,1,1,0-1.271h2.755a.635.635,0,0,1,0,1.271Z",
    transform: "translate(-922.716 -143.462)",
    fill: "#ddd7e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(137.491 64.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(5.948 2.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M887.7,160.154h-5.948v-11.47a2.974,2.974,0,1,1,5.948,0Z",
    transform: "translate(-881.753 -145.71)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(0 2.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M880.989,160.154h-5.948v-11.47a2.974,2.974,0,1,1,5.948,0Z",
    transform: "translate(-875.041 -145.71)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(17.855 2.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M901.139,160.154h-5.948v-11.47a2.974,2.974,0,0,1,5.948,0Z",
    transform: "translate(-895.191 -145.71)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(1.422 0.635)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 2.713,
    height: 2.713,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235",
    transform: "translate(7.565 0.635)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 2.713,
    height: 2.713,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(19.473 0.892)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 2.713,
    height: 2.713,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(0.766 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M879.3,144.443H876.54a.635.635,0,1,1,0-1.27H879.3a.635.635,0,1,1,0,1.27Z",
    transform: "translate(-875.905 -143.173)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(6.827 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M886.135,144.443H883.38a.635.635,0,1,1,0-1.27h2.755a.635.635,0,1,1,0,1.27Z",
    transform: "translate(-882.745 -143.173)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(18.817 0.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M899.665,144.733h-2.754a.635.635,0,0,1,0-1.271h2.754a.635.635,0,0,1,0,1.271Z",
    transform: "translate(-896.276 -143.462)",
    fill: "#ddd7e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(174.972 90.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(0 1.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M923.287,188.876h-5.948v-11.47a2.974,2.974,0,0,1,5.948,0Z",
    transform: "translate(-917.339 -174.432)",
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(1.617 0.635)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 2.713,
    height: 2.713,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(0.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M921.813,173.455h-2.755a.635.635,0,1,1,0-1.271h2.755a.635.635,0,0,1,0,1.271Z",
    transform: "translate(-918.423 -172.184)",
    fill: "#ddd7e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(148.133 84.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(0 4.588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M904.182,188.37H887.051l1.772-17.132H902.41Z",
    transform: "translate(-887.051 -171.238)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(0.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M888.871,170.648l-1.187-2.127a1.655,1.655,0,0,1,1.445-2.461h13.429a1.654,1.654,0,0,1,1.334,2.633l-1.434,1.955Z",
    transform: "translate(-887.472 -166.061)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    transform: "translate(4.345 9.174)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 8.442,
    height: 8.442,
    rx: 1.39,
    fill: "#c7bfce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(85.669 59.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    transform: "translate(0 4.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M833.691,160.057H816.559l1.772-17.132h13.587Z",
    transform: "translate(-816.559 -142.925)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(0.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M818.379,142.335l-1.187-2.128a1.654,1.654,0,0,1,1.444-2.46h13.429a1.654,1.654,0,0,1,1.334,2.633l-1.434,1.955Z",
    transform: "translate(-816.98 -137.748)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(4.345 9.174)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 8.442,
    height: 8.442,
    rx: 1.39,
    fill: "#c7bfce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    transform: "translate(91.553 6.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(0 3.671)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 14.849,
    cy: 9.162,
    rx: 14.849,
    ry: 9.162,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(1.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M827.537,78.094a.873.873,0,0,1,1.484-.286l2.518,2.9,3.509,4.047-5.259,1.015L824.53,86.79l1.75-5.062Z",
    transform: "translate(-824.53 -77.507)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(17.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M851.019,78.094a.873.873,0,0,0-1.484-.286l-2.518,2.9-3.509,4.047,5.259,1.015,5.259,1.016-1.75-5.062Z",
    transform: "translate(-843.507 -77.507)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_822",
    "data-name": "Group 822",
    transform: "translate(383.069 203.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 49.032,
    height: 24.305,
    rx: 6.341,
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(17.284 18.149)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 12.832,
    height: 23.753,
    fill: "#eeecf1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(6.178 2.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M785.624,215.873l-10.833-.076a.274.274,0,0,1,0-.549l10.833.076a.274.274,0,0,1,0,.549Z",
    transform: "translate(-774.518 -215.248)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_821",
    "data-name": "Group 821",
    transform: "translate(498.615 199.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649",
    transform: "translate(0 17.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M916.09,228.428H899.083a1.143,1.143,0,0,1,0-2.286H916.09Z",
    transform: "translate(-897.94 -226.142)",
    fill: "#c7bfce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(10.634 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M945.156,208.558v35.418H909.941V208.558a2.118,2.118,0,0,1,2.118-2.118h30.979A2.118,2.118,0,0,1,945.156,208.558Z",
    transform: "translate(-909.941 -206.44)",
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651",
    transform: "translate(10.634 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M945.156,208.558v6.548H909.941v-6.548a2.118,2.118,0,0,1,2.118-2.118h30.979A2.118,2.118,0,0,1,945.156,208.558Z",
    transform: "translate(-909.941 -206.44)",
    fill: "#c7bfce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652",
    transform: "translate(42.259 12.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M945.9,235.843a.274.274,0,0,1-.274-.275V221.188a.274.274,0,1,1,.548,0v14.381A.275.275,0,0,1,945.9,235.843Z",
    transform: "translate(-945.63 -220.913)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_820",
    "data-name": "Group 820",
    transform: "translate(340.363 236.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(72.822 0.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    d: "M0,0H138.14a2.583,2.583,0,0,1,2.583,2.583V91.176a2.583,2.583,0,0,1-2.583,2.583H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    fill: "#c4bcc9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    transform: "translate(0 0.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    d: "M19.262,0H196.5a2.809,2.809,0,0,1,2.809,2.809V90.95a2.809,2.809,0,0,1-2.809,2.809H2.78A2.78,2.78,0,0,1,0,90.98V19.262A19.262,19.262,0,0,1,19.262,0Z",
    fill: "#d3ccd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658",
    transform: "translate(98.946 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M831.454,342.552a.442.442,0,0,1-.442-.442V248.746a.442.442,0,0,1,.884,0V342.11A.443.443,0,0,1,831.454,342.552Z",
    transform: "translate(-831.012 -248.304)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659",
    transform: "translate(132.628 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M869.465,342.552a.443.443,0,0,1-.442-.442V248.746a.442.442,0,0,1,.884,0V342.11A.442.442,0,0,1,869.465,342.552Z",
    transform: "translate(-869.023 -248.304)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(166.398 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M907.575,342.948a.442.442,0,0,1-.442-.442V248.746a.442.442,0,1,1,.884,0v93.759A.442.442,0,0,1,907.575,342.948Z",
    transform: "translate(-907.133 -248.304)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(31.348 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M755.17,342.948a.442.442,0,0,1-.442-.442V248.746a.442.442,0,1,1,.884,0v93.759A.442.442,0,0,1,755.17,342.948Z",
    transform: "translate(-754.728 -248.304)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(65.119 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M793.28,342.948a.442.442,0,0,1-.442-.442V248.746a.442.442,0,1,1,.884,0v93.759A.442.442,0,0,1,793.28,342.948Z",
    transform: "translate(-792.838 -248.304)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    transform: "translate(208.951 44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 18.679,
    cy: 18.679,
    r: 18.679,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611",
    transform: "translate(4.028 4.028)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 14.652,
    cy: 14.652,
    r: 14.652,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(13.647 11.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M2.36,8.468a.6.6,0,0,1-.218-.042.589.589,0,0,1-.356-.41L.017.73A.591.591,0,0,1,1.165.452L2.736,6.925,12.545.513a.591.591,0,0,1,.647.99L2.683,8.372A.59.59,0,0,1,2.36,8.468Z",
    transform: "translate(4.234 0) rotate(30)",
    fill: "#a89fb3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(320.045 148.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    transform: "translate(82.945 167.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M717.718,341.115l-.207,7.463H703.517l-1.151-7.463Z",
    transform: "translate(-702.366 -341.115)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679",
    transform: "translate(41.536 154.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M674.009,334.674l-5.121,9.433-13.253-8.866,5.041-9.149Z",
    transform: "translate(-655.635 -326.092)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(36.569 52.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M650.066,313.958c1.067.479,25.276,12.186,25.9,12.186s10.2-40.381,10.2-40.381,3.387,43.441,4.062,43.441,27.127-.468,27.127-1.4-4.976-67.922-5.39-74.26-2.069-19.973-2.069-19.973l1.241-14.342-8.3-6.218s-23.174-8.549-27.225,10.019c-.773,3.572-2.232,9.116-4.083,15.737l.293.141a1.754,1.754,0,0,1,.8,2.342l-.654,1.339a1.743,1.743,0,0,1-1.786.969C662.2,271.661,649.249,313.6,650.066,313.958Z",
    transform: "translate(-650.029 -211.042)",
    fill: "#ffae64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681",
    transform: "translate(56.72 80.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M672.77,247.088a1.19,1.19,0,0,0,2.045.013l1.092-1.928a2.793,2.793,0,0,0-.91-3.085l-.876.209C673.7,243.843,673.238,245.444,672.77,247.088Z",
    transform: "translate(-672.77 -242.088)",
    fill: "#ea6d59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(79.435 172.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M698.4,363.614c0,1.552.527,3.331,1.6,3.771s9.725,1.388,17.305.727c7.244-.632,8.984-3.895,8.353-5.467-.3-.756-.606-1.484-.837-2.006a7.458,7.458,0,0,0-.814-1.428,25.425,25.425,0,0,1-2.737-4.479c-.526-1.552-1.324-4.884-1.858-6.443a2.838,2.838,0,0,0-1.842-1.866S702.656,345.4,701.6,346.3s-1.6,8.215-1.6,9.321v1.113c0,1.291-1.109,4.136-1.476,5.942A5.122,5.122,0,0,0,698.4,363.614Z",
    transform: "translate(-698.404 -345.93)",
    fill: "#bc574a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(10.744 160.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M667.195,341.9s-14.457-8.789-15.955-8.838-17.72,1.782-17.72,1.782-5.4-1.3-8.67.178-4.246,5.2-3.9,5.922,34.825,21.81,36.043,21.641S664.586,349.951,667.195,341.9Z",
    transform: "translate(-620.886 -333.063)",
    fill: "#bc574a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    transform: "translate(62.235 80.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M689.882,288.039a.267.267,0,0,1-.268-.26c-.447-15.1-.424-38.15-.421-40.424l-10.033-4.095a.267.267,0,1,1,.2-.494l10.2,4.162a.268.268,0,0,1,.166.248c0,.245-.047,24.774.421,40.588a.267.267,0,0,1-.26.275Z",
    transform: "translate(-678.994 -242.745)",
    fill: "#bc574a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(87.116 180.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M707.347,357.515a.275.275,0,0,1-.171-.489c3.937-3.135,9.627-.156,9.866-.027a.274.274,0,1,1-.258.483c-.055-.03-5.614-2.937-9.267-.027A.275.275,0,0,1,707.347,357.515Z",
    transform: "translate(-707.072 -355.596)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689",
    transform: "translate(86.646 177.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M706.816,353.558a.274.274,0,0,1-.17-.489c3.937-3.136,9.626-.156,9.865-.027a.274.274,0,0,1-.258.483c-.057-.031-5.613-2.937-9.266-.027A.276.276,0,0,1,706.816,353.558Z",
    transform: "translate(-706.542 -351.639)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    transform: "translate(32.446 161.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M651.274,337.539a.279.279,0,0,1-.141-.039l-5.623-3.375a.274.274,0,0,1,.283-.471l5.622,3.375a.274.274,0,0,1-.141.51Z",
    transform: "translate(-645.377 -333.616)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691",
    transform: "translate(27.345 162.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M643.387,337.648a.28.28,0,0,1-.161-.052l-3.492-2.524a.275.275,0,0,1,.322-.445l3.493,2.524a.275.275,0,0,1-.161.5Z",
    transform: "translate(-639.62 -334.576)",
    fill: "#f7c537"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(16.244 24.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M648.23,187.872s1.737-3.718.962-5.782-1.672-3.074-2.812-2.382-.392,2.619-1.7,3.634-9.153-.068-10.273-.478-4.857-3.483-5.417-1.76a2.178,2.178,0,0,0,.933,2.577s-3.175-3.163-2.8.326,6.547,6.315,11.118,6.117A38.5,38.5,0,0,0,648.23,187.872Z",
    transform: "translate(-627.092 -179.491)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693",
    transform: "translate(21.597 29.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M676,184.588s-6.82,7.226-13.823,9.374c-6.541,2.006-10.649-3.655-10.649-3.655l-18.4,3s5.23,25.683,28.3,24.916c20.083-.667,24.352-11.281,24.352-11.281Z",
    transform: "translate(-633.134 -184.588)",
    fill: "#ffae64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694",
    transform: "translate(47.322 66.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M705.465,226.138A49.038,49.038,0,0,1,690,227.179c-9.246-.7-13.213-.845-13.213-.845l-14.624,49.457s10.178,7.425,30.074,6.725,23.96-3.222,23.96-3.222l-4-43.13Z",
    transform: "translate(-662.165 -226.138)",
    fill: "#507849"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695",
    transform: "translate(67.399 2.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M684.822,158.26s2.105-5.266,9.372-3.33,7.421,7.077,7.421,7.077,2.75.043,1.9,5.257-7.033,10.156-9.325,6.414-2.214-12.334-2.214-12.334Z",
    transform: "translate(-684.822 -154.502)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(61.053 26.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M716.673,238s14.762-9.662,14.647-21.677c-.143-14.772-16.057-29.82-26.8-32.717s-20.644-2.884-24.656,1.791-1.305,35.87-1.305,35.87,5.66,1.987,15.451,2.094a38.891,38.891,0,0,0,17-3.7l-4.717,1.764Z",
    transform: "translate(-677.66 -181.618)",
    fill: "#ffae64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(69.472 22.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M687.161,178.324v.174l.125,3.284.087,2.575s-.224.6,2.774.423c4.018-.249,5.324-1.965,5.324-1.965l.212-6.033-1.219.224Z",
    transform: "translate(-687.161 -176.781)",
    fill: "#f78f77"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704",
    transform: "translate(69.472 22.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M687.161,178.528l.125,3.284c1.953-.223,5.51-1.045,6.966-4.1a2.5,2.5,0,0,0,.211-.659l-7.289,1.43Z",
    transform: "translate(-687.161 -177.048)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(65.549 5.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M685.49,160.661S681.7,169.184,683.01,174s5.694,4.084,8.318,3.173a8.663,8.663,0,0,0,3.85-2.508,3.691,3.691,0,0,0,4.09-1.418c1.651-2.262.661-4.881-.731-5.489a3.841,3.841,0,0,0-3.059.39l1.318-2.476S691.407,153.008,685.49,160.661Z",
    transform: "translate(-682.734 -158.203)",
    fill: "#f78f77"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709",
    transform: "translate(68.216 15.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M686.154,172.719a.28.28,0,0,1-.267-.2,4.855,4.855,0,0,1,.779-3.771.279.279,0,0,1,.456.321,4.364,4.364,0,0,0-.7,3.285.281.281,0,0,1-.184.349A.3.3,0,0,1,686.154,172.719Z",
    transform: "translate(-685.744 -168.634)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(78.378 16.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M697.49,173.565a.278.278,0,0,1-.2-.47l2.323-2.461a.279.279,0,1,1,.4.383l-2.323,2.461A.279.279,0,0,1,697.49,173.565Z",
    transform: "translate(-697.212 -170.547)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(79.23 18.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M700.059,173.106c-.042,0-1.648-.246-1.648-.246a.279.279,0,0,1,.083-.551l1.607.243a.279.279,0,0,1-.042.555Z",
    transform: "translate(-698.173 -172.306)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(69.63 19.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M689.038,175.911a2.558,2.558,0,0,1-1.619-.748.278.278,0,0,1,.111-.459l3.341-1.111a.278.278,0,0,1,.355.343,3.171,3.171,0,0,1-1.477,1.806A1.566,1.566,0,0,1,689.038,175.911Zm-.841-.842a1.328,1.328,0,0,0,1.3.174,2.348,2.348,0,0,0,.942-.92Z",
    transform: "translate(-687.339 -173.579)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(71.937 11.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M691.989,166.037a.277.277,0,0,1-.248-.152c-.385-.748-1.415-.541-1.461-.532a.279.279,0,0,1-.117-.545,1.924,1.924,0,0,1,2.074.822.279.279,0,0,1-.121.376A.27.27,0,0,1,691.989,166.037Z",
    transform: "translate(-689.943 -164.764)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    transform: "translate(67.12 10.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M686.753,164.956a.28.28,0,0,1-.23-.121.737.737,0,0,0-.521-.355,1.617,1.617,0,0,0-1.031.407.279.279,0,0,1-.37-.417,2.164,2.164,0,0,1,1.47-.542,1.279,1.279,0,0,1,.914.594.279.279,0,0,1-.23.436Z",
    transform: "translate(-684.507 -163.917)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715",
    transform: "translate(67.12 12.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M685.158,168.845a.285.285,0,0,1-.276-.319l.216-1.467-.53-.656a.278.278,0,1,1,.432-.35l.607.75a.276.276,0,0,1,.059.216l-.233,1.589A.28.28,0,0,1,685.158,168.845Z",
    transform: "translate(-684.507 -165.95)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716",
    transform: "translate(71.536 12.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M690.453,169.256a.285.285,0,0,1-.276-.314l.185-1.456-.789-.777a.279.279,0,1,1,.391-.4l.888.875a.276.276,0,0,1,.082.234l-.2,1.592A.28.28,0,0,1,690.453,169.256Z",
    transform: "translate(-689.49 -166.232)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717",
    transform: "translate(66.834 4.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M695.644,167.953s-3.731-1.912-5.08-4.6a11.325,11.325,0,0,1-1.4-4.034,3.525,3.525,0,0,1-1.906,2.176,10.387,10.387,0,0,1-2.206.462l-.867,2.505.565-5.972a33.727,33.727,0,0,1,4.179-1.97c.494,0,6.719,1.117,7.079,1.491s2.322,5.21,2.322,5.21l.136,2.184Z",
    transform: "translate(-684.184 -156.52)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718",
    transform: "translate(58.453 38.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M678.219,223.273a.274.274,0,0,1-.274-.264c0-.057-.217-5.677-.445-6.921a18.925,18.925,0,0,0-.555-1.84,42,42,0,0,1-2.177-9.214c-.43-4.937,2.567-9.251,2.694-9.432a.274.274,0,1,1,.448.315c-.03.043-3.008,4.335-2.6,9.069a41.571,41.571,0,0,0,2.151,9.089,18.8,18.8,0,0,1,.575,1.914c.233,1.281.443,6.766.451,7a.273.273,0,0,1-.262.284Z",
    transform: "translate(-674.727 -195.486)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719",
    transform: "translate(92.292 56.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M713.188,222a.274.274,0,0,1-.206-.456c.241-.27,5.973-6.61,12.025-6.19a.274.274,0,1,1-.038.548c-5.816-.417-11.521,5.942-11.576,6.007A.278.278,0,0,1,713.188,222Z",
    transform: "translate(-712.913 -215.334)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720",
    transform: "translate(97.58 53.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M719.156,217.286a.274.274,0,0,1-.255-.375c.21-.53,2.093-5.189,3.709-5.475a.956.956,0,0,1,.918.35,1.241,1.241,0,0,1,.306,1.062c-.293,1.875-4.365,4.3-4.538,4.4A.284.284,0,0,1,719.156,217.286Zm3.625-5.319a.419.419,0,0,0-.076.008c-.861.152-2.151,2.491-2.963,4.344,1.335-.883,3.377-2.446,3.55-3.557a.7.7,0,0,0-.174-.613A.443.443,0,0,0,722.781,211.968Z",
    transform: "translate(-718.882 -211.42)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721",
    transform: "translate(68.798 27.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M688.91,185.826a10.61,10.61,0,0,1-2.3-.246.273.273,0,0,1-.208-.327.269.269,0,0,1,.326-.207c4.855,1.072,9.389-1.979,9.435-2.01a.274.274,0,0,1,.309.453A14.754,14.754,0,0,1,688.91,185.826Z",
    transform: "translate(-686.401 -182.989)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722",
    transform: "translate(80.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M700.5,159.073s4.531-10.285,9.613-6.776-1.573,12.888-7.623,11.405S700.5,159.073,700.5,159.073Z",
    transform: "translate(-699.167 -151.567)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723",
    transform: "translate(77.397 68.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M709.533,228.778s-8.73.187-11.628,5.471-1.618,7.255-.82,7.931a3.655,3.655,0,0,0,1.221.784,3.735,3.735,0,0,0,1.6,1.85,2.267,2.267,0,0,0,2.013.061,9.026,9.026,0,0,0,2.448,1.817,3.651,3.651,0,0,0,2.648-.929c.224-.348,2.277-3.547,2.277-3.547a2.2,2.2,0,0,0,2.113.289c2.994-1.1,4.65-6.047,4.65-6.047S712.006,227.955,709.533,228.778Z",
    transform: "translate(-696.104 -228.722)",
    fill: "#f78f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724",
    transform: "translate(79.321 75.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M698.554,244.2a.224.224,0,0,1-.048,0,.278.278,0,0,1-.227-.322,21,21,0,0,1,2.361-6.609.279.279,0,0,1,.47.3,20.863,20.863,0,0,0-2.282,6.4A.277.277,0,0,1,698.554,244.2Z",
    transform: "translate(-698.275 -237.137)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725",
    transform: "translate(82.938 77.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M702.637,246.391a.249.249,0,0,1-.05,0,.28.28,0,0,1-.224-.324,23.983,23.983,0,0,1,2.108-6.341.283.283,0,0,1,.381-.1.28.28,0,0,1,.1.381,23.891,23.891,0,0,0-2.044,6.164A.279.279,0,0,1,702.637,246.391Z",
    transform: "translate(-702.358 -239.582)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726",
    transform: "translate(87.132 64.181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 21.676,
    height: 4.988,
    rx: 1.973,
    transform: "matrix(-0.518, -0.855, 0.855, -0.518, 11.239, 21.121)",
    fill: "#618958"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727",
    transform: "translate(19.879 31.327)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 21.676,
    height: 4.988,
    rx: 1.973,
    transform: "translate(22.172 4.935) rotate(171.601)",
    fill: "#618958"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728",
    transform: "translate(45.93 38.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M661.57,200.958a.887.887,0,0,1-.834-.436c-.673-1.18,1.226-4.508,1.614-5.163a.27.27,0,0,1,.267-.133.275.275,0,0,1,.23.187c.045.142,1.118,3.475.089,4.9a1.59,1.59,0,0,1-1.365.649Zm.932-4.755c-.781,1.434-1.642,3.432-1.29,4.047.043.074.121.16.358.16a1.054,1.054,0,0,0,.921-.421C663.082,199.175,662.787,197.331,662.5,196.2Z",
    transform: "translate(-660.593 -195.226)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729",
    transform: "translate(17.755 27.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M634.788,184.97a.277.277,0,0,1-.1-.02l-5.712-2.3a.279.279,0,0,1,.207-.517l5.635,2.271,3.924-.821a.279.279,0,1,1,.114.546l-4.007.839A.314.314,0,0,1,634.788,184.97Z",
    transform: "translate(-628.798 -182.11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730",
    transform: "translate(0 22.579)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 26.006,
    cy: 2.769,
    rx: 26.006,
    ry: 2.769,
    fill: "#ddd7e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731",
    transform: "translate(19.086 24.112)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 10.805,
    cy: 0.618,
    rx: 10.805,
    ry: 0.618,
    fill: "#c8bece"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736",
    transform: "translate(22.58 8.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732",
    transform: "translate(0 0.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M640.348,177.657a6.1,6.1,0,0,1-6.1-6.1V161.7h12.208v9.858A6.1,6.1,0,0,1,640.348,177.657Z",
    transform: "translate(-634.243 -161.695)",
    fill: "#f2513b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 6.104,
    cy: 0.701,
    rx: 6.104,
    ry: 0.701,
    fill: "#eeecf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735",
    transform: "translate(7.645 1.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M647.434,174.9c-2.516,0-4.563-2.644-4.563-5.895s2.047-5.895,4.563-5.895S652,165.754,652,169,649.95,174.9,647.434,174.9Zm0-10.71c-1.92,0-3.484,2.16-3.484,4.815s1.564,4.815,3.484,4.815,3.483-2.16,3.483-4.815S649.355,164.189,647.434,164.189Z",
    transform: "translate(-642.871 -163.11)",
    fill: "#f2513b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741",
    transform: "translate(80.567 40.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738",
    transform: "translate(0 1.168)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 4.726,
    cy: 2.916,
    rx: 4.726,
    ry: 2.916,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739",
    transform: "translate(0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M701.062,196.9a.278.278,0,0,1,.472-.091l.8.924,1.117,1.288-1.674.323-1.674.323.557-1.611Z",
    transform: "translate(-700.105 -196.709)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740",
    transform: "translate(5.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M708.536,196.9a.278.278,0,0,0-.472-.091l-.8.924-1.117,1.288,1.674.323,1.674.323-.556-1.611Z",
    transform: "translate(-706.145 -196.709)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetain2);
export default __webpack_public_path__ + "static/media/retain2.58108303645936d47c4de9b4233e656d.svg";
export { ForwardRef as ReactComponent };